import { flatten } from './flatten';
import { purry } from './purry';
export function flatMap() {
  return purry(_flatMap, arguments, flatMap.lazy);
}

function _flatMap(array, fn) {
  return flatten(array.map(function (item) {
    return fn(item);
  }));
}

(function (flatMap) {
  function lazy(fn) {
    return function (value) {
      var next = fn(value);

      if (Array.isArray(next)) {
        return {
          done: false,
          hasNext: true,
          hasMany: true,
          next: next
        };
      }

      return {
        done: false,
        hasNext: true,
        next: next
      };
    };
  }

  flatMap.lazy = lazy;
})(flatMap || (flatMap = {}));